import { detectScriptType } from './detectScriptType'

const scriptType = detectScriptType()
const hasEnv = scriptType === 'background' || scriptType === 'popup'

export const fetchEnv = (key: string) => {
  if (hasEnv) {
    // @ts-ignore
    return import.meta.env[`VITE_${key}`]
  }
}
